import React from "react";
import { FormBuilder, Form } from "@redriver/cinnamon";
import { Image } from "semantic-ui-react";
import Search from "features/../../../shared/assets/purple-search.svg";

const TextSearch = ({ value, onChange, onFocus }) => (
  <FormBuilder
    value={value}
    onChange={onChange}
    renderForm={formProps => (
      <Form {...formProps}>
        <Form.Input
          field="search"
          placeholder="Search"
          icon={<Image src={Search} />}
          className="search-input highlighted-input"
          onFocus={onFocus}
        />
      </Form>
    )}
  />
);

export default TextSearch;
